import React from 'react';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';
import CloseIcon from '@liquidweb-dev/undercurrent/icons/lucide/X';
import Dialog, { type DialogProps } from '@liquidweb-dev/undercurrent/Dialog';
import DialogContent from '@liquidweb-dev/undercurrent/DialogContent';
import DialogTitle from '@liquidweb-dev/undercurrent/DialogTitle';
import IconButton from '@liquidweb-dev/undercurrent/IconButton';

interface WrapperProps extends Omit<DialogProps, 'onClose'> {
	title?: string;
	children: React.ReactNode;
	onClose: () => void;
}

const Wrapper = ({
	title,
	children,
	onClose,
	sx,
	...dialogProps
}: WrapperProps) => (
	<Dialog onClose={onClose} {...dialogProps}>
		<DialogTitle
			sx={{ fontWeight: 500, color: ({ vars }) => vars.palette.uc.text.main }}
		>
			{title || 'Cancel service'}
		</DialogTitle>
		<IconButton
			variant="barebones"
			size="large"
			onClick={onClose}
			aria-label="Close dialog"
			sx={{ position: 'absolute', right: '24px', top: '24px' }}
		>
			<CloseIcon />
		</IconButton>
		<DialogContent
			sx={combineSx(
				{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					paddingX: 300,
					paddingBottom: { xs: 700, sm: 300 },
				},
				sx,
			)}
		>
			{children}
		</DialogContent>
	</Dialog>
);

export default Wrapper;
